(() => {
  'use strict';
  function init(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const player = root.querySelector('.player');
  const video = player.querySelector('video');
  const start = player.querySelector('.start');
  const toggle = player.querySelector('.toggle');
  const seek = player.querySelector('.seek');
  const sound = player.querySelector('.sound');
  const controls = player.querySelector('.controls');
  const note = player.querySelector('.duration-note');
  const status = player.querySelector('.status');
  const time = player.querySelector('.time');
  let started = false;
  let pending = false;
  let operation = 0;
  let resumeAt = 0;
  const wideScreen = window.matchMedia('(min-width: 1000px)');
  const source = () => wideScreen.matches ? video.dataset.srcLandscape : video.dataset.src;
  const format = (seconds) => {
    const n = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0));
    return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, '0')}`;
  };
  function progress() {
    const duration = Number.isFinite(video.duration) ? video.duration : 60;
    seek.max = duration;
    seek.value = video.currentTime;
    seek.setAttribute('aria-valuetext', `${format(video.currentTime)} / ${format(duration)}`);
    time.textContent = `${format(video.currentTime)} / ${format(duration)}`;
    seek.disabled = !Number.isFinite(video.duration);
  }
  function setState(state) {
    player.dataset.state = state;
    start.disabled = state === 'loading';
    start.querySelector('span').textContent = state === 'loading' ? '読み込み中…' : state === 'error' ? 'もう一度再生' : 'みんなの感想を見る｜約1分';
    const label = state === 'ended' ? 'もう一度' : state === 'playing' ? '一時停止' : '再生する';
    toggle.setAttribute('aria-label', label);
    toggle.querySelector('.toggle-text').textContent = label;
    toggle.querySelector('.toggle-icon').textContent = state === 'playing' ? 'Ⅱ' : state === 'ended' ? '↻' : '▶';
    controls.hidden = !started || state === 'error' || state === 'loading';
    note.hidden = !controls.hidden;
  }
  function fail() {
    pending = false;
    setState('error');
    status.textContent = '動画を読み込めませんでした。もう一度お試しください。詳しい内容は下のボタンからご覧いただけます。';
  }
  async function play() {
    if (pending) return;
    pending = true;
    const attempt = ++operation;
    status.textContent = '';
    const initial = !started || player.dataset.state === 'error';
    const transferFocus = document.activeElement === start;
    if (initial) {
      setState('loading');
      video.src = source();
      video.load();
    }
    if (video.ended) video.currentTime = 0;
    try {
      await video.play();
      if (attempt !== operation) return;
      started = true;
      setState('playing');
      if (transferFocus) toggle.focus({preventScroll:true});
    } catch (error) {
      if (attempt !== operation) return;
      // Backgrounding during loading is a pause, not a network failure.
      if (error.name === 'AbortError' && document.hidden) {
        setState(started ? 'paused' : 'poster');
      } else fail();
    } finally { if (attempt === operation) pending = false; }
  }
  function syncSound() {
    sound.textContent = video.muted ? '音声OFF' : '音声ON';
    sound.setAttribute('aria-label', video.muted ? '音声をオンにする' : '音声をオフにする');
    sound.setAttribute('aria-pressed', String(!video.muted));
  }
  sound.addEventListener('click', () => { video.muted = !video.muted; syncSound(); });
  video.addEventListener('volumechange', syncSound);
  syncSound();
  start.addEventListener('click', play);
  toggle.addEventListener('click', () => video.paused || video.ended ? play() : video.pause());
  video.addEventListener('playing', () => { started = true; setState('playing'); });
  video.addEventListener('pause', () => { if (started && !video.ended) setState('paused'); });
  video.addEventListener('ended', () => { setState('ended'); progress(); });
  video.addEventListener('error', fail);
  video.addEventListener('loadedmetadata', () => {
    if (resumeAt > 0 && Number.isFinite(video.duration)) {
      video.currentTime = Math.min(resumeAt, video.duration - 0.1);
      resumeAt = 0;
    }
    progress();
  });
  // On a format change, show the matching cover and wait for the next user click.
  // Keep the viewing position without fetching a second video in the background.
  wideScreen.addEventListener('change', () => {
    if (!video.hasAttribute('src')) return;
    resumeAt = video.ended ? 0 : video.currentTime;
    ++operation;
    video.pause();
    started = false;
    pending = false;
    video.removeAttribute('src');
    video.load();
    status.textContent = '';
    setState('poster');
    progress();
  });
  video.addEventListener('timeupdate', progress);
  seek.addEventListener('input', () => { video.currentTime = Number(seek.value); progress(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && !video.paused) video.pause();
    }, {threshold:0});
    observer.observe(player.querySelector('.picture'));
  }
  }
  function initAll() { document.querySelectorAll('[data-kazu-experience]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
